import { useCallback, useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';
import { useIntl } from 'react-intl';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { getMediaItemStatsQuery } from 'modules/media/graphql/mediaStats/queries';
import { formatValue } from '@ts-core/utils/dataTableUtils';

import { useFilteredData } from '@ts-core/hooks/ui';

export default function useMediaItemStats({ courseId, subjectId, mediaId }) {
  const intl = useIntl();
  const {
    data,
    loading,
    error,
    refetch: onFetchStats,
  } = useQuery(getMediaItemStatsQuery, {
    variables: { courseId, subjectId, mediaId },
    skip: !courseId || !subjectId || !mediaId,
    fetchPolicy: 'network-only',
  });
  const mediaStats = useMemo(() => data?.mediaStats || {}, [data]);
  const { students: allStudents, ...others } = mediaStats;
  const { filteredData: students, onFilterData: onFilterStats } = useFilteredData({
    list: allStudents,
    fields: ['name', 'email'],
  });

  const onGetXlsxData = useCallback(
    (sortedData) => {
      const headers = [
        intl.formatMessage({ id: 'field.name.label' }),
        intl.formatMessage({ id: 'field.email.label' }),
        intl.formatMessage({ id: 'assignmentResultsTable.group' }),
        intl.formatMessage({ id: 'mediaStatsTable.totalViews' }),
        intl.formatMessage({ id: 'mediaStatsTable.avgProgress' }),
        intl.formatMessage({ id: 'mediaStatsTable.maxProgress' }),
      ];

      const xlsxData = [headers];

      sortedData.forEach((rowData) => {
        const { _original: student } = rowData;

        const mediaStatsData = [
          student.name,
          student.email,
          student.group?.name,
          student.totalViews,
          formatValue(student.avgProgressPercentage, 1),
          formatValue(student.maxProgressPercentage, 1),
        ];

        return xlsxData.push(mediaStatsData);
      });

      return xlsxData;
    },
    [intl]
  );

  return {
    loading,
    error: getErrorMessage({ error }),
    mediaStats: {
      ...others,
      students,
    },
    onFilterStats,
    onFetchStats,
    onGetXlsxData,
  };
}
